const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;

const { InspectorControls } = wp.blockEditor;

const {
	FormTokenField,
	PanelBody,
	PanelRow,
	Disabled,
	RangeControl,
	SelectControl,
	TextControl,
} = wp.components;
const { serverSideRender: ServerSideRender } = wp;
const { withSelect } = wp.data;
const { createElement: el } = wp.element;

/**
 * Internal dependencies
 */
import store from '../../../store';
import icons from "../../../icons.js";

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
 registerBlockType("wp-apidae/entities-criteria", {
	title: __("Fiches avec critères", "wp-apidae"), // Block title.
	description: __("Affiche une liste de fiches répondant à certains critères.", "wp-apidae"),
	icon: {
		foreground: '#EFB114',
		background: '#331F5B',
		src: icons.entitiesCriteria
	},
	supports: {
    align: ['full','wide'],
  },
	attributes: {
		post_type: {
      type: "string",
      default: "any",
    },
		taxonomy: {
      type: "array",
      default: [],
    },
		terms: {
      type: "array",
      default: [],
    },
		terms_operator: {
      type: "string",
      default: "IN",
    },
		limit: {
      type: "number",
      default: 3,
    },
		orderby: {
      type: "string",
      default: "title",
    },
		order: {
      type: "string",
      default: "ASC",
    },
		columns: {
			type: "number",
			default: 2,
		},
		align: {
			type: 'string',
			default: '',
		},
	},
	edit: class extends wp.element.Component {
		render() {
			const props = this.props;
			const attributes = props.attributes;

			/**
     * Set Apidae Post Types
     */
			 function onChangePostType(value) {
				props.setAttributes({ post_type: value });
			}
	
			/**
			 * Select Apidae Post Types.
			 */
			 const post_types_select = withSelect((select) => {
				const { isResolving } = select("core/data");
				return {
					postTypeData: select("wpdae/data").getApidaePostTypeList(),
					isRequesting: isResolving("wpdae/data", "getApidaePostTypeList", []),
				};
			})((props) => {
				if (props.isRequesting) {
					// still resolving; so display a "loading" indicator
					return el("div", null, "Chargement des types de post...");
				}
	
				const post_types_list = [{ value: "any", label: "Tous les types de post" }];
				for (const [key, value] of Object.entries(props.postTypeData)) {
					post_types_list.push({value: value.name, label: value.label});
				}
	
				return (
					<SelectControl
						onChange={onChangePostType}
						value={attributes.post_type}
						label={__("Choisir un type de post", "wp-apidae")}
						options={post_types_list}
					/>
				);
			});
	
			/**
			 * Taxonomies
			 */
			 const TaxoFilter = withSelect((select) => {
				const { isResolving } = select("core/data");
				return {
					taxonomies: select("core").getTaxonomies({ per_page: -1 }),
					isRequesting: isResolving("core", "getTaxonomies",{ per_page: -1 }),
				};
			})((props) => {
				if (props.isRequesting) {
					// still resolving; so display a "loading" indicator
					return el("div", null, "Chargement des taxinomies...");
				} else {
					let taxoNames = [];
					let taxosFieldValue = [];
					taxoNames = props.taxonomies.map( (taxo) => taxo.name );
					taxosFieldValue = attributes.taxonomy.map( ( taxoID ) => {
						let wantedTaxo = props.taxonomies.find( ( taxo ) => {
							return taxo.slug === taxoID;
						} );
						if ( wantedTaxo === undefined || ! wantedTaxo ) {
							return false;
						}
						return wantedTaxo.name;
					} );
					return (
						<FormTokenField
							value={taxosFieldValue}
							suggestions={taxoNames}
							onChange={ ( taxonomy ) => {
								let selectedTaxosArray = [];
								taxonomy.map(
									( taxoName ) => {
										const matchingTaxo = props.taxonomies.find( ( taxo ) => {
											return taxo.name === taxoName;
										} );
										if ( matchingTaxo !== undefined ) {
											selectedTaxosArray.push( matchingTaxo.slug )
										}
									}
								)
								this.props.setAttributes( { taxonomy: selectedTaxosArray } );
							} }
							placeholder={__("Ajouter une taxinomie", "wp-apidae")}
							label={__(
								"Taxinomie",
								"wp-apidae"
							)}
							maxLength={1}
						/>
					);
				}
			});
	
	
			/**
			 * terms
			 */
			const TermsFilter = withSelect((select) => {
				const { isResolving } = select("core/data");
				return {
					terms: select("core").getEntityRecords(
						"taxonomy",
						attributes.taxonomy[0],
						{ per_page: 100 }
					),
					isRequesting: isResolving("core", "getEntityRecords",[
						"taxonomy",
						attributes.taxonomy[0],
						{ per_page: 100 }
					]),
				};
			})((props) => {
				if (props.isRequesting) {
					// still resolving; so display a "loading" indicator
					return el("div", null, "Chargement des termes...");
				} else {
					if ( null === props.terms || props.terms.length === 0 ) {
						return el("div", null, "Pas de termes disponibles");;
					}
					let termNames = [];
					let termsFieldValue = [];
	
					termNames = props.terms.map( (term) => term.name );
					termsFieldValue = attributes.terms.map( ( termID ) => {
						let wantedTerm = props.terms.find( ( term ) => {
							return term.slug === termID;
						} );
						if ( wantedTerm === undefined || ! wantedTerm ) {
							return false;
						}
						return wantedTerm.name;
					} );
					return (
						<PanelRow>
						<FormTokenField
							value={termsFieldValue}
							suggestions={termNames}
							onChange={ ( terms ) => {
								let selectedTermsArray = [];
								terms.map(
									( termName ) => {
										const matchingTerm = props.terms.find( ( term ) => {
											return term.name === termName;
										} );
										if ( matchingTerm !== undefined ) {
											selectedTermsArray.push( matchingTerm.slug )
										}
									}
								)
								this.props.setAttributes( { terms: selectedTermsArray } );
							} }
							placeholder={__("Ajouter un terme", "wp-apidae")}
							label={__(
								"Termes",
								"wp-apidae"
							)}
						/>
						</PanelRow>
					);
				}
			});
	
			/**
			 * Define terms_operator
			 */
			 function onChangeTermsOperator(value) {
				props.setAttributes({ terms_operator: value });
			}
	
			/**
			 * Define orderby
			 */
			 function onChangeOrderBy(value) {
				props.setAttributes({ orderby: value });
			}
			/**
			 * Define order
			 */
			 function onChangeOrder(value) {
				props.setAttributes({ order: value });
			}


			return [
					<InspectorControls key={"inspector"}>
						<PanelBody title={__("General")}>
						<PanelRow>
						{el(post_types_select)}
          </PanelRow>
          <PanelRow>
          <RangeControl
              label='Nombre de fiches'
							value={attributes.limit}
							min={0}
							max={100}
							onChange={(newValue) => {
								props.setAttributes({ limit: Number(newValue) });
							}}
						/>
						</PanelRow>
						<PanelRow>
						<TextControl
								type="number"
								label={__("Nombre de colonnes")}
								value={attributes.columns}
								min={`1`}
								max={`5`}
								onChange={(newValue) => {
									props.setAttributes({ columns: Number(newValue) });
								}}
							/>
          </PanelRow>
					<PanelRow>
          {el(TaxoFilter)}
					</PanelRow>
          {el(TermsFilter)}
          { attributes.terms.length !== 0 &&
            <PanelRow>
            <SelectControl
              onChange={onChangeTermsOperator}
              value={attributes.terms_operator}
              label={__("Opérateur", "wp-apidae")}
              options={[{value:'IN',label:'IN'},{value:'NOT IN',label:'NOT IN'},{value:'AND',label:'AND'}]}
            />
            </PanelRow>
          }
            <PanelRow>
            <SelectControl
              onChange={onChangeOrderBy}
              value={attributes.orderby}
              label={__("Ordre", "wp-apidae")}
              options={[{value:'title',label:'Titre'},{value:'rand',label:'Aléatoire'}]}
            />
            </PanelRow>
            <PanelRow>
            <SelectControl
              onChange={onChangeOrder}
              value={attributes.order}
              label={__("Sens d'affichage", "wp-apidae")}
              options={[{value:'ASC',label:'ASC'},{value:'DESC',label:'DESC'}]}
            />
            </PanelRow>
						</PanelBody>
					</InspectorControls>,
				<Disabled>
				<ServerSideRender
					block="wp-apidae/entities-criteria"
					attributes={attributes}
					/>
			</Disabled>
				,
			];
		}
	},

	save: () => {
		return null;
	},
});
